// extracted by mini-css-extract-plugin
export default {"field":"EmailEditPopup_field__0amXX","text":"EmailEditPopup_text__gc27R"};